import Ribbon, { propTypes as RibbonPropTypes } from './Ribbon';
import SpecialRibbon from './SpecialRibbon';

export default Ribbon;

export { Ribbon, RibbonPropTypes, SpecialRibbon }



// WEBPACK FOOTER //
// ./src/components/RibbonNew/index.jsx